import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setData } from "../../redux/app/Actions"
import Send from "../../communication"

export const useAssistanceResolve = (getCounter = false) => {
  const { user, scope } = useSelector((state) => state.app)
  const dispatch = useDispatch()
  const [dataResolve, setDataResolve] = useState([])
  const [loadingDataToResolve, setLoadingDataToResolve] = useState(false)
  const [reload, setReload] = useState(false)

  const loadDataAssistanceToResolve = async (getCounter) => {
    let res
    let counter = 0

    if (getCounter) {
      try {
        res = await Send.get(`/assistance-to-resolve/user/${user?.user?.id}/count`)
        counter = (res && res[0]["COUNT(ar.id)"]) || 0
      } catch (error) {
        console.log("Erro ao buscar contagem dos atendimentos pendentes")
      }
    } else {
      try {
        setLoadingDataToResolve(true)
        res = await Send.get(`/assistance-to-resolve/user/${user?.user?.id}/pending`)
        counter = (res && res?.length) || 0

        if (counter > 0) {
          setDataResolve(res)
        }
      } catch (error) {
        console.log("Erro ao buscar atendimentos pendentes")
      }
      finally{
        setLoadingDataToResolve(false)
      }
    }

    const notifications = {
      counter,
      notifications: [
        {
          notificationInfo: "Atendimentos Pendentes",
          notificationCount: counter,
          notificationText: "Você tem atendimentos para resolver",
          notificationLink: "/assistance/resolve",
        },
      ],
    }

    if (counter > 0) {
      dispatch(
        setData({
          allNotifications: notifications,
        }),
      )
    }
  }

  useEffect(() => {
    if (scope?.id || reload) {
      loadDataAssistanceToResolve(getCounter)
    }
    setReload(false)
  }, [scope, reload])

  return { dataResolve, setReload, loadingDataToResolve }
}